'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    ripple: {
      type: Boolean,
      default: true
    },
    rippleColor: {
      type: String,
      default: ''
    },
    rippleOpacity: {
      type: Number
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/muse-ui/lib/internal/mixins/ripple.js
// module id = E6J+
// module chunks = 1